<template lang="pug">
  .header__collection
    .header__collection-image
    .header__collection-text
      p GORILLA
      span(v-html="collectionItemText")
      .header__collection-text_attention
        .attention-point
        | {{ $t('header.collection_new') }}
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderCollection',
  computed: {
    ...mapState('siteVersions', {
      siteVersion: 'item'
    }),
    collectionItemText: (vm) => {
      if (vm.siteVersion.code === 'ru') {
        return vm.$t('header.collection.ultimate')
      }

      if (['kz', 'global'].includes(vm.siteVersion.code)) {
        return vm.$t('header.collection.apricot')
      }

      return ''
    }
  }
}
</script>
